import "./App.scss";
import ImageMobileProduct from "./images/image-product-mobile.jpg";
import ImageDesktopProduct from "./images/image-product-desktop.jpg";
import IconCart from "./images/icon-cart.svg";
import { useMediaQuery } from "react-responsive";
function App() {
  const isDesktop = useMediaQuery({
    query: "(min-width: 1920px)",
  });

  return (
    <div className="App">
      <div className="main">
        <img
          className="main__image"
          alt="mobile-product"
          src={`${isDesktop ? ImageDesktopProduct : ImageMobileProduct}`}
        />
        <div className="main__product">
          <span className="main__product__category">Perfume</span>
          <p className="main__product__title">
            Gabrielle Essence Eau De parfum
          </p>
          <p className="main__product__description">
            A floral, solar and voluptuous interpration composed by Olivier
            Palge, Perfumer - Creator for the House of CHANEL.
          </p>
          <div className="main__product__price">
            <span className="main__product__price__new">$149.99</span>
            <span className="main__product__price__old">
              <s>$169.99</s>
            </span>
          </div>
          <button className="main__product__button">
            <img src={IconCart} />
            <span>Add to cart</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
